import {
  IconType,
  type TagQueryFilter,
} from "@package/ui-gql/index-data-access";
import { type WritableDraft } from "immer";
import { sortBy, uniq } from "lodash";
import { useMemo, useState } from "react";
import { ICON_TYPE_TO_DISPLAY } from "../../constants/constants";
import { useItemGridFilterContext } from "../ItemGridFilter/context-item-grid-filter";
import {
  ItemGridFilterDataList,
  type FilterValueEntry,
} from "../ItemGridFilter/ItemGridFilterDataList";

type SupportedFilter = TagQueryFilter | null | undefined;

export function ItemGridFilterIconType() {
  const [query, setQuery] = useState<string>("");

  const { filter, updateFilterState } = useItemGridFilterContext();

  const filterWithIconType: SupportedFilter = filter;
  const items = useMemo<FilterValueEntry[]>(() => {
    const values: FilterValueEntry[] =
      Object.values(IconType)
        .map((type) => {
          const id = type;
          const name = ICON_TYPE_TO_DISPLAY[type];
          const checked = filterWithIconType?.iconType?.includes(id) ?? false;
          return {
            id,
            name,
            checked,
          };
        })
        .filter((entry) =>
          entry.name.toLowerCase().includes(query.toLowerCase()),
        ) ?? [];

    return sortBy(values, (entry) => entry.name);
  }, [filterWithIconType?.iconType, query]);

  return (
    <ItemGridFilterDataList
      items={items}
      property="iconType"
      text="Icon Type"
      onQueryValueChanged={setQuery}
      onRequestFilterReset={() =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            delete draft.iconType;
          }
        })
      }
      onRequestFilterUpdate={(id, include) =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (include) {
              draft.iconType = uniq([
                ...(draft.iconType ?? []),
                id as IconType,
              ]);
            } else if (draft.iconType?.length) {
              draft.iconType = draft.iconType.filter((type) => type !== id);
            }

            if (!draft.iconType?.length) {
              delete draft.iconType;
            }
          }
        })
      }
      onSelectAllChanged={(checked) => {
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (checked) {
              draft.iconType = Object.values(IconType);
            } else {
              delete draft.iconType;
            }
          }
        });
      }}
    />
  );
}
